import React, { Component }  from "react";
import { Link } from "react-router-dom";
import formatLink from "../../utils/formatLink";
import axios from 'axios';
import Alert from "../../components/Alert/Alert";
import css from './FieldJobForms.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import {connect} from "react-redux";

const SurveyForm = class extends Component{
    source = axios.CancelToken.source();
    pickfields = [];
    generalFields = ['Site_Survey_Outcome__c', 'What_Was_Partially_Completed__c', 'What_Was_Fully_Completed__c', 'Any_unpermitted_structures__c', 'Was_the_customer_home__c', 'Drone_Survey__c'];

    componentDidMount(){
        // Used to get picklist values for the below fields
        axios.get(
            '/sf/fieldjob/describeField/Ceiling_Type__c;Roof_mossy_or_slippery__c;Attic_Structure__c;Roof_Type__c;Roof_Condition__c;Roof_mossy_or_slippery__c;' +
            'Structure_2_Ceiling_Type__c;Structure_2_Attic_Structure__c;Structure_2_Roof_Mossy_or_Slippery__c;Structure_2_Fragile_or_Lightweight_Tile__c;' +
            'Structure_2_Roof_Condition__c;Structure_2_Roof_Type__c;Waste_Management_Method__c;Siding_Type__c;Utility_Feed__c;MSP_Mounting__c;Grounding__c;' +
            'MSP_Condition__c;MSP_Brand__c;MSP_Feed__c;Main_Breaker_Rating__c;MSP_Busbar_Rating__c;Existing_PV_Breaker_Size__c;Existing_ACD__c;Select_materials_in_the_trench_path__c;' +
            'What_Was_Partially_Completed__c;What_Was_Fully_Completed__c;Site_Survey_Outcome__c;What_Was_The_Reason_For_Cancelling__c',
            {
                cancelToken: this.source.token
            })
            .then((resPickFields) => {
                this.pickfields = resPickFields.data;
            })
            .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
    }

    state = {
        isEditing: false,
        shouldShowAlert: false,
        Id: this.props.fieldJob.Id,
        Site_Survey_Outcome__c: this.props.fieldJob.Site_Survey_Outcome__c,
        What_Was_Partially_Completed__c: this.props.fieldJob.What_Was_Partially_Completed__c,
        What_Was_Fully_Completed__c: this.props.fieldJob.What_Was_Fully_Completed__c,
        What_Was_The_Reason_For_Cancelling__c: this.props.fieldJob.What_Was_The_Reason_For_Cancelling__c,
        Needs_follow_up__c: this.props.fieldJob.Needs_follow_up__c,
        Job_Notes__c: this.props.fieldJob.Job_Notes__c
    };

    saveFields = () => {
        const payload = {...this.state};

        if(this.validationSaveCheck(payload)) {
            this.setState({shouldShowAlert: false, alertMessage: ''});

            delete payload.isEditing;
            delete payload.alertMessage;
            delete payload.shouldShowAlert;

            axios.put(
                '/sf/fieldjob/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.props.onSave(true);
                    setTimeout(() => {
                        this.setState({isEditing: false});
                    }, 1500);
                })
                .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
        }
    };

    endJob = () => {
        const payload = {...this.state};

        if(this.validationCompleteCheck(payload)) {
            this.setState({shouldShowAlert: false, alertMessage: ''});
            delete payload.isEditing;
            delete payload.alertMessage;
            delete payload.shouldShowAlert;

            payload.Clocked_End__c = moment().format(this.SF_DATE_TIME_FORMAT);
            payload.Status__c = 'Complete';
            payload.Completed_By__c = this.props.user.apiId;

            axios.put(
                '/sf/fieldjob/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.props.onSave(true);
                    setTimeout(() => {
                        this.setState({isEditing: false});
                    }, 1500);
                })
                .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
        }
    };

    validationSaveCheck = (payload) => {
        let valid = true;

        if(payload['Job_Notes__c'] !== null && payload['Job_Notes__c'].length > 5000) {
            this.setState({shouldShowAlert: true, alertMessage: 'Too Many Characters for Field Notes'})
            valid = false;
        }

        return valid;
    };

    validationCompleteCheck = (payload) => {
        let valid = true; 

        if(this.validationSaveCheck(payload)){
            if(this.props.session.Survey_Type__c !== null && this.state.Site_Survey_Outcome__c !== 'Cancelled') {
                for (const key in payload) {
                    if(this.generalFields.includes(key)){
                        if(key === 'Site_Survey_Outcome__c' && payload[key] === 'Partial Completion' && payload['What_Was_Partially_Completed__c'] === null) {
                            this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out General Section Before Ending Job'})
                            valid = false;
                            break;
                        } else if(key === 'Site_Survey_Outcome__c' && payload[key] === 'Full Completion' && payload['What_Was_Fully_Completed__c'] === null) {
                            this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out General Section Before Ending Job'})
                            valid = false;
                            break;
                        } else if(key !== 'What_Was_Partially_Completed__c' && key !== 'What_Was_Fully_Completed__c' && payload[key] === null) {
                            this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out General Section Before Ending Job'})
                            valid = false;
                            break;
                        }
                    }
                }
            }

            if(this.state.Site_Survey_Outcome__c === 'Cancelled') {
                if(payload['What_Was_The_Reason_For_Cancelling__c'] === null || payload['Needs_follow_up__c'] === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out Reason for Cancellation and if Follow up is Needed'});
                    valid = false;
                }
            }
        } else {
            valid = false;
        }

        return valid;
    };

    getInput = (inputType, field, fieldProps, fieldStateOptions) => {
        switch (inputType) {
            case 'yesNo':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.setState({[field]: event.target.value})}>
                            <option disabled value=""></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                );
            case 'picklist':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.setState({[field]: event.target.value})}>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'num':
                return(
                    <div className="pb-4">
                        <input
                            type="number"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            case 'text':
                return(
                    <div className="pb-4">
                        <input
                            type="text"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            case 'textarea':
                return(
                    <div className="pb-4">
                        <textarea
                            rows="5"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            default:
                return(
                    <div>
                        Not
                    </div>
                );
        };
    }

    render(){
      return (
        <div className={css.FieldJobForms}>
            <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage} <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({shouldShowAlert: false, alertMessage: ''})} /></Alert>
            <div className="d-flex justify-content-between mt-5 mb-4">
                {/* the ternary expression prevents user from clicking the link before `schedulableId` has been fetched: */}
                <Link to={ this.props.session.Id ? `/scheduled/${this.props.session.Id}` : ''}>
                    <button className="btn btn-outline" type="button">Back</button>
                </Link>

                <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                    <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                    <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveFields()}>Save</button>
                </div>

                <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                    <a
                        href={formatLink(this.props.session.Jobsite_Photos__c ? this.props.session.Jobsite_Photos__c : '')}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button className="btn btn-outline">Upload</button>
                    </a>
                    <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                </div>
            </div>

            <div className={this.props.fieldJob.Clocked_End__c ? 'd-none' : ''}>
                <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.endJob()}>End Job</button>
            </div>

            <div className={this.props.fieldJob.Clocked_End__c ? '' : 'd-none'}>
                <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.endJob()}>Job Completed</button>
            </div>
            {
                this.state.isEditing ?
                // Render when editing
                <div className="text-white">
                    <h2 className="pt-4">Outcome</h2>
                    <div>
                        <label htmlFor="Site_Survey_Outcome__c">Site Survey Outcome *</label>
                        {this.getInput('picklist', 'Site_Survey_Outcome__c', this.state.Site_Survey_Outcome__c, this.pickfields.Site_Survey_Outcome__c.picklistValues)}
                    </div>

                    <div className={this.state.Site_Survey_Outcome__c === 'Cancelled' ? 'd-none' : ''}>

                        <div className={this.state.Site_Survey_Outcome__c === 'Partial Completion' || this.state.Site_Survey_Outcome__c === null ? '' : 'd-none'}>
                            <label htmlFor="What_Was_Partially_Completed__c">What was partially completed? *</label>
                            {this.getInput('picklist', 'What_Was_Partially_Completed__c', this.state.What_Was_Partially_Completed__c, this.pickfields.What_Was_Partially_Completed__c.picklistValues)}
                        </div>
                        <div className={this.state.Site_Survey_Outcome__c === 'Full Completion' ? '' : 'd-none'}>
                            <label htmlFor="What_Was_Fully_Completed__c">What was fully completed? *</label>
                            {this.getInput('picklist', 'What_Was_Fully_Completed__c', this.state.What_Was_Fully_Completed__c, this.pickfields.What_Was_Fully_Completed__c.picklistValues)}
                        </div>
                    </div> 
                    {/* End of Canelled Check */}

                    <div className={this.state.Site_Survey_Outcome__c === 'Cancelled' ? '' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What Was The Reason For Cancelling? *</label>
                            {this.getInput('picklist', 'What_Was_The_Reason_For_Cancelling__c', this.state.What_Was_The_Reason_For_Cancelling__c, this.pickfields.What_Was_The_Reason_For_Cancelling__c.picklistValues)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Follow up Needed? *</label>
                            {this.getInput('yesNo', 'Needs_follow_up__c', this.state.Needs_follow_up__c)}
                        </div>
                    </div>

                    <h2 className="pt-4">Field Notes</h2>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Field Notes</label>
                        {this.getInput('textarea', 'Job_Notes__c', this.state.Job_Notes__c)}
                    </div>

                </div>

                :

                // Render when not editing
                <div className="text-white">
                    <h2 className="pt-4">General</h2>

                    <label className="col-sm-5 col-12 m-0 py-2">Site Survey Outcome</label>
                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Site_Survey_Outcome__c ? this.props.fieldJob.Site_Survey_Outcome__c : '---'}</div>

                    <div className={this.state.Site_Survey_Outcome__c === 'Cancelled' ? 'd-none' : ''}>
                        <div className={this.state.Site_Survey_Outcome__c === 'Partial Completion' || this.state.Site_Survey_Outcome__c === null ? 'mt-0' : 'd-none'}>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What Was Partially Completed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_Was_Partially_Completed__c ? this.props.fieldJob.What_Was_Partially_Completed__c : '---'}</div>
                        </div>
                        <div className={this.state.Site_Survey_Outcome__c === 'Full Completion' ? 'mt-0' : 'd-none'}>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What Was Fully Completed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_Was_Fully_Completed__c ? this.props.fieldJob.What_Was_Fully_Completed__c : '---'}</div>
                        </div>
                    </div>

                    <div className={this.state.Site_Survey_Outcome__c === 'Cancelled' ? '' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What Was The Reason For Cancelling?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_Was_The_Reason_For_Cancelling__c ? this.props.fieldJob.What_Was_The_Reason_For_Cancelling__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Follow up Needed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Needs_follow_up__c ? this.props.fieldJob.Needs_follow_up__c : '---'}</div>
                        </div>
                    </div>

                    <h2 className="pt-4">Field Notes</h2>
                    <div>
                        <label className="text-white col-sm-5 col-6 m-0 py-2">Field Notes</label>
                        <div className={this.props.fieldJob.Job_Notes__c ? "col-12" : "d-inline col-sm-7 col-12"}>{this.props.fieldJob.Job_Notes__c ? this.props.fieldJob.Job_Notes__c : '---'}</div>
                    </div>

                </div>
            }

            <div className="mt-5 mb-4">
                <div className={this.props.fieldJob.Clocked_End__c ? 'd-none' : ''}>
                    <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.endJob()}>End Job</button>
                </div>

                <div className={this.props.fieldJob.Clocked_End__c ? '' : 'd-none'}>
                    <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.endJob()}>Job Completed</button>
                </div>
                <div className="d-flex justify-content-between mt-3">
                    {/* the ternary expression prevents user from clicking the link before `schedulableId` has been fetched: */}
                    <Link to={ this.props.session.Id ? `/scheduled/${this.props.session.Id}` : ''}>
                        <button className="btn btn-outline" type="button">Back</button>
                    </Link>

                    <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                        <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                        <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveFields()}>Save</button>
                    </div>

                    <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                        <a
                            href={formatLink(this.props.session.Jobsite_Photos__c ? this.props.session.Jobsite_Photos__c : '')}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="btn btn-outline">Upload</button>
                        </a>
                        <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                    </div>

                </div>
            </div>

        </div>
    )};
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(SurveyForm);